import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c4q5qhejkf: FaireBrandEntity = {
  token: "b_c4q5qhejkf",
  type: "brand",
  name: "K & S WHOLESALE INC",
  avatarUrl:
    "https://cdn.faire.com/fastly/a4485226f60812566dc43427409cd9069d1ecf7f8d6ed402a69f8cada1a0591f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0700f8f823e1f9af083570a5560fd2fafa750602887ac1f5654c4b620efae33f.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/a4485226f60812566dc43427409cd9069d1ecf7f8d6ed402a69f8cada1a0591f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0700f8f823e1f9af083570a5560fd2fafa750602887ac1f5654c4b620efae33f.webp",
  location: "Syosset, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 174,
  isInsider: true,
  description:
    "Welcome to K&S Wholesale, your number one source for all things including Phone accessories, toys, electronics and much more. We are dedicated to providing you the very best of all of our product line, with an emphasis on quality, lowest rates, and customer service.\n\nFounded in 2005 by our Managing Director Majid Haroon, K&S started 15 years ago as a sole distributor of Phone accessories. Starting with one warehouse In The Bronx, now K&S has expanded its operations to 3 warehouses in Long Island with a wide inventory of phones accessories, toys, electronics, and much more.\n\nWe love serving our customers and we will continue to do so for foreseeable future.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:04.079Z",
    importedBy: "entity-db-cli",
  },
};
